export const inArrayCheckCode = (array, code) => {
  for (let i = 0; i < array.length; i++) {
    if (array[i].code === code) { return true; }
  }
  return false;
};

export const verifyResponses = (preguntas, respuestas) => {
  let isIt = false;
  // recorro las preguntas!
  for (let j = 0; j < preguntas.length; j++) {
    for (let x = 0; x < preguntas[j].subCategories.length; x++) {
      for (let y = 0; y < preguntas[j].subCategories[x].questions.length; y++) {
        if (
          preguntas[j].subCategories[x].questions[y].codeQuestion !== "Q2" &&
          preguntas[j].subCategories[x].questions[y].codeQuestion !== "Q3" &&
          preguntas[j].subCategories[x].questions[y].codeQuestion !== "Q5"
        ) {
          // recorro las respuestas para verificar si está la pregunta, ignorando las que no puedo modificar
          for (let i = 0; i < respuestas.length; i++) {
            switch (preguntas[j].subCategories[x].questions[y].type) {
              case "COMPOSITE":
                if (
                  (preguntas[j].subCategories[x].questions[y].codeQuestion === respuestas[i].code)
                  &&
                  (respuestas[i].response.length === 2 && respuestas[i].responseadicional.length === 2)
                ) {
                  isIt = true;
                }
                break;

              case "TEXT":
              case "JUST_ONE":
              case "NUMBER":
              case "AT_LEAST_ONE":
              default:
                if (preguntas[j].subCategories[x].questions[y].codeQuestion === respuestas[i].code) {
                  isIt = true;
                }
                break;
            }
          }
          if (!isIt) {
            if ( preguntas[j].subCategories[x].title === "" && !preguntas[j].subCategories[x].title ){
              return `Revise las preguntas de la categoría [${j + 1}. ${preguntas[j].title}], todas son requeridas.`;
            }
            return `Revise las preguntas de la categoría [${j + 1}. ${preguntas[j].title}], sección [${j + 1}.${x + 1}. ${preguntas[j].subCategories[x].title}], todas son requeridas.`;
          }
          isIt = false;
        } else if (preguntas[j].subCategories[x].questions[y].codeQuestion === "Q5") {
          let suma = 0;
          for (let i = 0; i < respuestas.length; i++) {
            if (respuestas[i].code === "Q5") {
              // sumo las respuestas
              for (let k = 0; k < respuestas[i].responseadicional.length; k++) {
                suma += parseInt(respuestas[i].responseadicional[k]);
              }
              break;
            }
          }
          if (suma < 1) {
            return "Debe tener al menos 1 trabajador en el centro. Revise las preguntas de la categoría [2. Información de los Trabajadores].";
          }
        }
      }
    }
  }
  return null;
};
